<div class="sectionContainer paddedContent">
  <div class="flex-container" style="gap: 20px">
    <div style="flex: 1">
      <div class="column">
        <app-text-input
          [label]="'MID'"
          [required]="true"
          [(ngModel)]="this.processorToEdit.mid"
          [readonly]="readonly || this.processorToEdit.mid != undefined"
        ></app-text-input>
      </div>

      <div class="column">
        <app-text-input
          [label]="'Amex Merchant ID'"
          [required]="false"
          [(ngModel)]="this.processorToEdit.amexMerchantId"
          [readonly]="readonly"
        ></app-text-input>
      </div>

      <div class="column">
        <app-ddl-input
          [label]="'Status'"
          [required]="true"
          [(ngModel)]="this.processorToEdit.status"
          [options]="status"
          [readonly]="readonly"
        ></app-ddl-input>
      </div>
    </div>
    <div style="flex: 1">
      <div class="column">
        <app-ddl-input
          [label]="'Processor Type'"
          [required]="true"
          [(ngModel)]="this.processorToEdit.processorType"
          [options]="processorType"
          [readonly]="readonly"
        ></app-ddl-input>
      </div>

      <div class="column">
        <app-ddl-input
          [label]="'Processor'"
          [required]="true"
          [(ngModel)]="this.processorToEdit.processor"
          [options]="processor"
          [readonly]="readonly"
        ></app-ddl-input>
      </div>

      <div class="column">
        <app-ddl-input
          [label]="'Gateway'"
          [required]="true"
          [(ngModel)]="this.processorToEdit.gateway"
          [options]="gateway"
          [readonly]="readonly"
        ></app-ddl-input>
      </div>
    </div>
  </div>

  <div style="width: 100%; text-align: center" [hidden]="readonly">
    <input
      type="button"
      value="Save"
      class="button_secondary button_var_2 button_right-spacing"
      (click)="btnSave_click()"
      (keydown.enter)="btnSave_click()"
    />
    <input
      type="button"
      value="Cancel"
      class="button_secondary button_var_2"
      (click)="btnCancel_click()"
      (keydown.escape)="btnCancel_click()"
    />
  </div>
</div>
